export const nodeTypes = {
  AnchorPoint: 0,
  Ctr1Point: 1,
  Ctr2Point: 2
}
